<div
  class="campaign-scrim"
  [class.campaign-scrim--preview]="preview"
  (click)="onScrimClick($event)"
>
  <div
    #modalEl
    class="campaign-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    (click)="$event.stopPropagation()"
  >
    <div class="campaign-modal__media" *ngIf="hasMedia">
      <img *ngIf="isImage" [src]="campaign.media.url" alt="" />
      <video *ngIf="isFileVideo" [src]="campaign.media.url" controls></video>
      <iframe
        *ngIf="isEmbeddedVideo"
        [src]="videoEmbedUrl"
        title=""
        frameborder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>

    <button
      type="button"
      class="campaign-modal__close"
      [attr.aria-label]="'inAppCampaigns.modal.close' | translate"
      (click)="onDismiss()"
    >
      &times;
    </button>

    <div class="campaign-modal__body">
      <span class="campaign-modal__badge" *ngIf="campaign?.badgeLabel">{{ campaign.badgeLabel }}</span>
      <h3 class="campaign-modal__title" [id]="titleId">{{ campaign?.title }}</h3>
      <p class="campaign-modal__description">{{ campaign?.description }}</p>
      <button
        #primaryButton
        type="button"
        class="campaign-modal__cta"
        (click)="onPrimaryClick()"
      >
        {{ campaign?.action?.buttonLabel }}
      </button>
    </div>
  </div>
</div>
